<template>
  <div>
    <form>
      <div class="search-group">
        <input v-model="query" type="search" class="form-control" name="" value="">
        <button type="button" class="btn btn-primary" @click="_searchRefreshListener"><i class="icon wb-reload" aria-hidden="true"></i>
        </button>
      </div>
    </form>
    <tree-node :treeNodes="innerTreeNodes" @changeNode="_changeNodeListener"/>
  </div>
</template>

<script>
import TreeNode from './tree-node'

export default {
  components: {
    TreeNode
  },

  props: ['treeNodes'],

  data () {
    return {
      query:          null,
      backupNodes:    null,
      innerTreeNodes: null
    }
  },

  created () {
    this.backupNodes    = this.treeNodes
    this.innerTreeNodes = this.treeNodes
  },

  watch: {
    query: function (value) {
      if (!value || value === '') {
        this.innerTreeNodes = this.backupNodes

        return
      }

      this.innerTreeNodes = this._searchInNodes(value, JSON.parse(JSON.stringify(this.backupNodes)))
    }
  },

  methods: {

    /**
     *
     * @param treeNode
     * @private
     */
    _changeNodeListener (treeNode) {
      this.$emit('changeNode', treeNode)
    },

    /**
     *
     * @param query
     * @param nodes
     * @param result
     * @private
     */
    _searchInNodes (query, nodes, result = []) {
      nodes.forEach((item) => {
        let nodeName      = item.NAME.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
            preparedQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

        if (nodeName.includes(preparedQuery)) {
          // delete item.SUBTREE
          result.push(item)
        }

        if (item.hasOwnProperty('SUBTREE') && item.SUBTREE.length) {
          let subtrees = this._searchInNodes(query, item.SUBTREE)
          subtrees.forEach((subItem) => {
            // delete item.SUBTREE
            result.push(subItem)
          })
        }

      })

      return result
    },

    _searchRefreshListener () {
      this.innerTreeNodes = this.backupNodes
      this.query          = null
    }
  }
}
</script>
